import React, {Fragment} from 'react';
import _isEqual from "lodash/isEqual";
import {
    Grid
} from '@material-ui/core';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {CaseItem} from '../../component'
import {casesList} from '../../vendors/actions/case'


interface OwnProps {
    Cases?: any,
    getCases?: any,
    CaseTypes?: any,
    States?: any
}

interface ConnectStateProps {
    Cases: any,
}

interface ConnectDispatchProps {

    getCases?: () => void;
}

interface MainState {
    cases: any | null,
}

type HeaderProps = OwnProps & ConnectStateProps & ConnectDispatchProps;

class Dashboard extends React.Component<HeaderProps, MainState> {
    state = {
        cases: []
    };

    componentDidMount() {
        this.props.getCases();
    }

    static getDerivedStateFromProps(props: any, state: any) {
        const {Cases} = props;
        if (!_isEqual(state.cases, Cases)) {
            return {
                cases: Cases
            };
        }
        return null;
    }

    render() {
        const {cases} = this.state;
        console.log('cases',cases)
        const list = cases.map((val: any, key: number) => <CaseItem data={val} key={key}/>);
        return (
            <Fragment>
                <Grid container spacing={1}>
                    {list}
                </Grid>
            </Fragment>
        );
    }
}

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {Cases} = state;
    return {
        Cases
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        getCases: () => dispatch(casesList())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



